import { LOGIN_METHOD } from '@gofranz/common';
import {
  OidcSecurityLogBanner,
  SecurityLogPage,
  useIdpHandoff,
  useOidcRefreshOnReturn,
} from '@gofranz/common-components';
import { API_BASE_URL } from '../../constants';
import { useRustyState } from '../../state';

export function AccountSecurityLogPage() {
  const { api } = useRustyState.getState();
  const session = useRustyState((state) => state.api?.auth?.getSession());
  const isOidc = session?.method === LOGIN_METHOD.OIDC;
  const apiRoot = API_BASE_URL.replace(/\/v1\/?$/, '');
  const { config: handoffConfig } = useIdpHandoff(apiRoot);

  useOidcRefreshOnReturn({ session, auth: api.auth });

  return (
    <SecurityLogPage
      getSecurityLog={(query) => api.getSecurityLog(query)}
      storageKey="formshive.securityLog.pagination"
      banner={isOidc ? <OidcSecurityLogBanner config={handoffConfig} /> : null}
    />
  );
}
